import { Button } from "@/components/ui/button";
import { Menu } from "lucide-react";
import { AutelionLogo } from "@/components/common/AutelionLogo";

export function Header() {
  return (
    <header className="border-b border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <AutelionLogo size="md" />
          <span className="text-xl font-bold text-foreground">- ComplyManager</span>
        </div>

        <nav className="hidden md:flex items-center space-x-6">
          <a href="#features" className="text-foreground hover:text-primary transition-colors">
            Features
          </a>
          <a href="#how-it-works" className="text-foreground hover:text-primary transition-colors">
            How It Works
          </a>
          <a href="#how-it-works" className="text-foreground hover:text-primary transition-colors">
            Use Cases
          </a>
          <a href="/docs" className="text-foreground hover:text-primary transition-colors">
            Docs
          </a>
        </nav>

        <div className="flex items-center space-x-4">
          <Button variant="outline" size="sm" className="hidden md:inline-flex" asChild>
            <a href="/auth">Sign In</a>
          </Button>
          <Button variant="hero" size="sm" asChild>
            <a href="/auth">Get Started</a>
          </Button>
          <Button variant="ghost" size="icon" className="md:hidden">
            <Menu className="h-5 w-5" />
          </Button>
        </div>
      </div>
    </header>
  );
}
